import React from 'react';
import { Calendar, CalendarRange, Clock, Grid, List } from 'lucide-react';
import { TabsList, TabsTrigger } from '../ui/tabs';

export default function ViewSelectorTabs() {
  return (
    <TabsList className="h-9 bg-muted/60 p-1">
      <TabsTrigger value="timeline" className="h-7 px-3 text-xs data-[state=active]:bg-background">
        <Clock className="mr-1.5 h-3.5 w-3.5" /> Timeline
      </TabsTrigger>
      <TabsTrigger value="list" className="h-7 px-3 text-xs data-[state=active]:bg-background">
        <List className="mr-1.5 h-3.5 w-3.5" /> Liste
      </TabsTrigger>
      <TabsTrigger value="calendar" className="h-7 px-3 text-xs data-[state=active]:bg-background">
        <Calendar className="mr-1.5 h-3.5 w-3.5" /> Kalender
      </TabsTrigger>
      <TabsTrigger value="floor" className="h-7 px-3 text-xs data-[state=active]:bg-background">
        <Grid className="mr-1.5 h-3.5 w-3.5" /> Floor
      </TabsTrigger>
      <TabsTrigger value="slots" className="h-7 px-3 text-xs data-[state=active]:bg-background">
        <CalendarRange className="mr-1.5 h-3.5 w-3.5" /> Slots
      </TabsTrigger>
    </TabsList>
  );
}
